import HWLocalStorage from "../HWLibrary/HWLocalStorage";

class S360Config {
  sourceOrigin = null; // SDK client origin.
  clientHostId = null; // SDK client host Id.
  config = {};
  userData = {};
  s360UserConfig = null;
  resumedWorkitemId = null;
  thrioConfig = {};

  chatHistory = null;
  activeSessions = {};
  termsAceeptedForSession = false;
  constructor() {
    if (!S360Config.instance) {
      S360Config.instance = this;
    }
    this.config = {};
    return S360Config.instance;
  }

  sendUserData = (data) => {
    this.userData = data;
    // call
    // xmppService.sendUserMetaData(data);
  };
  getConfig() {
    return this.config;
  }
  showDynamicForm = () => {
    let tempConfig = this.getConfig();
    tempConfig.showDynamicForm = true;

    this.loadS360Config(JSON.parse(JSON.stringify(tempConfig)));
  };
  setTermsAceeptedForThisSession = (value) => {
    this.termsAceeptedForSession = value;
  };
  // Configure client connection details.
  setSourceAndOriginFrom = (clientConfig) => {
    this.sourceOrigin = clientConfig.sourceOrigin;
    this.clientHostId = clientConfig.clientHostId;
  };

  isClientHostConfigured = () => {
    return !(!this.sourceOrigin || !this.clientHostId);
  };

  // this is where config is set
  setConfig = (recievedConfig) => {
    let tempConfig = {};
    this.config = recievedConfig;
  };

  loadS360Config = (data) => {
    //STEP 8
    if (data === null || data === undefined) {
      if (!this.isClientHostConfigured()) {
        return;
      }
      let chatConfigKey = this.clientHostId + "-s360-config-key";
      // this.config = HWLocalStorage.load(chatConfigKey) || {}; // Config variable below.
    } else {
      // if (!this.isClientHostConfigured()) {
      //   return;
      // }

      this.config = data; // Config variable below.
    }
  };

  isConfigured = () => {
    if (!this.isClientHostConfigured()) {
      return false;
    }
    let chatConfigKey = this.clientHostId + "-s360-config-key";
    return HWLocalStorage.load(chatConfigKey) != null;
  };

  loadClientConfigFromToken = () => {
    let configEncodedString = (window.location.pathname || "").substring(
      1,
      (window.location.pathname || "").length
    );
    if (!configEncodedString) {
      return;
    }
    let decodedConfig = this.decodeConfigToken(configEncodedString);
    if (!decodedConfig) {
      return null;
    }

    this.setSourceAndOriginFrom(decodedConfig);
    this.loadS360Config();
    this.loadS360UserConfig();
  };

  decodeConfigToken = function (encodedStringURI) {
    if (!encodedStringURI) {
      return null;
    }
    let decodedStringURI = decodeURIComponent(encodedStringURI);
    let decodedBase64String = atob(decodedStringURI);
    return JSON.parse(decodedBase64String);
  };

  // MARK: User From Configuration
  getUserConfig = () => {
    if (!this.isClientHostConfigured()) {
      return {};
    }
    let chatConfigKey = this.clientHostId + "-s360-user-config-key";
    return HWLocalStorage.load(chatConfigKey) || {};
  };

  setUserConfig = (config) => {
    let chatConfigKey = this.clientHostId + "-s360-user-config-key";
    HWLocalStorage.save(config, chatConfigKey);
    this.loadS360UserConfig(config);

    this.config.user = config;
  };

  loadS360UserConfig = (data) => {
    this.s360UserConfig = data; // user variable from setUser.
    if (!this.isClientHostConfigured()) {
      return;
    }
    let chatConfigKey = this.clientHostId + "-s360-user-config-key";
    let config = HWLocalStorage.load(chatConfigKey) || {};

    if (
      sessionStorage.getItem(`s360-user-config-${this.config.configId}`) ===
      null
    ) {
      sessionStorage.setItem(
        `s360-user-config-${this.config.configId}`,
        JSON.stringify(config)
      );
    }
  };

  isUserAttributesConfigured = () => {
    let chatConfigKey = this.clientHostId + "-s360-user-config-key";
    return HWLocalStorage.load(chatConfigKey) !== null;
  };
  returnUser = () => {
    return { data: this.s360UserConfig, success: this.s360UserConfig !== null };
  };
}

export var s360ConfigService = new S360Config();
// export var s360ConfigService = () => { return s360ConfigInstance; }
